export const EMPLOYMENT_STATUS = {
  PRIMARY: 1,
  SECONDARY: 2,
  PREVIOUS: 3,
};
